import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { EDeviceType } from '../../types/device';
import { EActiveView } from '../../types/view';
import { AuthenticationViewContainer } from '../../containers/AuthenticationViewContainer';
import { AuthenticationRegistrationViewContainer } from '../../containers/AuthenticationRegistrationViewContainer';
import { TwoFactorViewContainer } from '../../containers/TwoFactorViewContainer';
import { TwoFactorAttemptsExhaustedViewContainer } from '../../containers/TwoFactorAttemptsExhaustedViewContainer';
import { RestoreViewContainer } from '../../containers/RestoreViewContainer';
import { EmailSentViewContainer } from '../../containers/EmailSentViewContainer';
import { SocialCreateViewContainer } from '../../containers/SocialCreateViewContainer';
import { SocialMergeViewContainer } from '../../containers/SocialMergeViewContainer';
import { ConfirmPhoneViewContainer } from '../../containers/ConfirmPhoneViewContainer';
import { TwoFactorWithEmailViewContainer } from '../../containers/TwoFactorWithEmailViewContainer';
import { Provider as ResponsiveProvider } from '../Responsive';
import * as styles from './styles.css';
export var Authentication = /*#__PURE__*/function (_React$Component) {
  _inherits(Authentication, _React$Component);

  var _super = _createSuper(Authentication);

  function Authentication() {
    _classCallCheck(this, Authentication);

    return _super.apply(this, arguments);
  }

  _createClass(Authentication, [{
    key: "render",
    value: function render() {
      var deviceTypeOriginal = this.props.deviceType;
      return /*#__PURE__*/React.createElement(ResponsiveProvider, {
        deviceType: deviceTypeOriginal || EDeviceType.Desktop
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, this.renderView()));
    }
  }, {
    key: "renderView",
    value: function renderView() {
      var _this$props = this.props,
          activeView = _this$props.activeView,
          returnUrl = _this$props.returnUrl,
          stepFlow = _this$props.stepFlow,
          disabledSocials = _this$props.disabledSocials;

      switch (activeView) {
        case EActiveView.AuthenticationRegistration:
          if (stepFlow) {
            return /*#__PURE__*/React.createElement(AuthenticationViewContainer, {
              disabledSocials: disabledSocials
            });
          }

          return /*#__PURE__*/React.createElement(AuthenticationRegistrationViewContainer, {
            returnUrl: returnUrl,
            disabledSocials: disabledSocials
          });

        case EActiveView.SocialCreate:
          return /*#__PURE__*/React.createElement(SocialCreateViewContainer, null);

        case EActiveView.SocialMerge:
          return /*#__PURE__*/React.createElement(SocialMergeViewContainer, null);

        case EActiveView.TwoFactor:
          return /*#__PURE__*/React.createElement(TwoFactorViewContainer, null);

        case EActiveView.TwoFactorWithEmail:
          return /*#__PURE__*/React.createElement(TwoFactorWithEmailViewContainer, null);

        case EActiveView.TwoFactorAttemptsExhausted:
          return /*#__PURE__*/React.createElement(TwoFactorAttemptsExhaustedViewContainer, null);

        case EActiveView.Restore:
          return /*#__PURE__*/React.createElement(RestoreViewContainer, null);

        case EActiveView.ConfirmPhone:
          return /*#__PURE__*/React.createElement(ConfirmPhoneViewContainer, null);

        case EActiveView.EmailSent:
          return /*#__PURE__*/React.createElement(EmailSentViewContainer, null);
      }

      return null;
    }
  }]);

  return Authentication;
}(React.Component);

_defineProperty(Authentication, "defaultProps", {
  disabledSocials: []
});